const Skeleton: React.FC = () => {
  return (
    <div className="bg-surface-100-bg mx-5 my-2.5">
      <div className="flex justify-between relative">
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-24 rounded-sm skeleton" />
        <div className="bg-surface-200-bg inline-block h-6 leading-8 w-20 rounded-700 skeleton" />
      </div>
      <div className="whitespace-nowrap overflow-hidden pt-2.5 -mx-5" style={{ flexFlow: 'wrap' }}>
        <div className="flex w-[462px]">
          {new Array(3).fill(0).map((_item, index) => {
            return (
              <div
                key={`skeleton-theme-list-item-${index}`}
                className="w-[150px] box-content mr-1.5 first:ml-5 last:mr-5">
                <div className="rounded-2xl overflow-hidden w-full skeleton bg-surface-200-bg relative">
                  <div className="w-full h-full default-img pt-[100%]"></div>
                </div>
                <div className="w-full h-[36px] mt-0.5 bg-surface-200-bg skeleon" />
                <div className="w-full h-4 mt-1 bg-surface-200-bg skeleon" />
                <div className="w-full h-4 mt-1 bg-surface-200-bg skeleon" />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
